'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');
module.exports = getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixTab extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:tab:active'];
        }

        get panelId() {
            if (!this._panelId) {
                const panelId = this.getAttr('for', { required: true });
                this._panelId = `${this.tabsId}-${panelId}`;
            }
            return this._panelId;
        }

        set activeState(val) {
            this.setAttribute('aria-selected', val);

            if (val) {
                this.setAttribute('tabindex', 0);
            } else {
                this.setAttribute('tabindex', -1);
            }
        }

        connectedCallback() {
            super.connectedCallback();
            this.phoenixTabs = this.closest('phoenix-tabs');
            this.tabsId = this.phoenixTabs && this.phoenixTabs.id;
            this.for = this.getAttr('for', { required: true });
            this.hashEnabled = this.phoenixTabs.hashEnabled;
            this.listenfor = this.getAttr('listenfor') || 'click';
            this._addListener();

            if (this.hashEnabled && this.phoenixTabs.hash && this.phoenixTabs.hash === this.for) {
                this._notify();
            }
        }

        broadcastedEventCallback(name, args = {}) {
            const tabsId = args.detail && args.detail.tabsId;
            const panelId = args.detail && args.detail.panelId;

            if (tabsId !== this.tabsId) {
                return;
            }

            switch (name) {
                case 'phoenix:tab:active':
                    this.activeState = this.panelId === panelId;
                    break;
            }
        }

        _addListener() {
            this.addEventListener(
                this.listenfor,
                this._notify,
                pageClass.util.supportPassiveEventListeners() ? { passive: true } : false
            );
        }

        _removeListener() {
            this.removeEventListener(this.listenfor, this._notify);
        }

        _notify() {
            if (this.hashEnabled) {
                this.phoenixTabs.hash = this.for;
            }

            const eventName = 'phoenix:tab';
            this.emitEvent(eventName, {
                bubbles: true,
                detail: {
                    key: eventName,
                    tabsId: this.tabsId,
                    panelId: this.panelId,
                },
            });
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this._removeListener();
        }
    }

    window.customElements.whenDefined('phoenix-tabs').then(() => {
        window.customElements.define('phoenix-tab', PhoenixTab);
    });
});
